"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @preferred
 */
var service_1 = require("../service");
var _ = require("lodash");
var Functionalities;
(function (Functionalities) {
    function getSupportedFunctionalities() {
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("GetSupportedFunctionalities");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {};
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response.Functionalities") || []);
            })
                .catch(reject);
        });
    }
    Functionalities.getSupportedFunctionalities = getSupportedFunctionalities;
})(Functionalities = exports.Functionalities || (exports.Functionalities = {}));
